<template>
    <b-modal
        id="modal-change-return-date"
        centered
        :title="$t('cdb.subscription.returnDate.title')"
        v-model="isVisible"
    >
        <b-form-group :label="$t('cdb.subscription.returnDate.label')" v-slot="{ ariaDescribedby}">
            <v-date-picker
                v-model="returnDate"
                :locale="$i18n.locale"
                :min-date="new Date()"
            >
                <template v-slot="{ inputValue, inputEvents }">
                    <input
                        type="text"
                        class="form-control form-control-md"
                        :value="inputValue"
                        v-on="inputEvents"
                    />
                </template>
            </v-date-picker>
        </b-form-group>
        <template #modal-footer="{ cancel }">
            <button type="button" class="btn btn-secondary" @click="cancel">{{ $t('co.payment_methods.button.cancel-new-payment-method') }}</button>
            <button type="button" class="btn btn-primary" @click="submit">{{ $t('cdb.subscription.returnDate.submit') }}</button>
        </template>
    </b-modal>
</template>

<script>
import {
    BModal,
    BFormGroup,
} from 'bootstrap-vue';
import { EventBus } from '../../event-bus'

export default {
    name: 'ModalChangeReturnDate',
    components: {
        BFormGroup,
        BModal,
    },
    data() {
      return {
          isVisible: false,
          returnDate: '',
          timestamps: {},
          uuid: '',
      }
    },
    mounted() {
        EventBus.$on('init-change-return-date', this.showModal);
    },
    methods: {
        showModal(data) {
            this.isVisible = true
            this.getData(data)
        },
        getData(data) {
            this.timestamps = data.timestamps
            this.uuid = data.subscriptionUuid
        },
        submit() {
            this.$axios.put('api/v1/dashboard/request_new_return_date', {
                'return_date_request': this.submittingDate,
                'subscription_uuid': this.uuid
            }).then(response => {
                if(response.data){
                    this.isSubmitting = false
                    this.isVisible = false
                    EventBus.$emit('cdb-reload-subscriptions', null);
                } else {
                    this.error = true
                }
            }).catch(error => {
                this.isSubmitting = false
                this.error = true
            });
        },
    },
    computed: {
        isValid() {
            return this.isVisible
        },
        formattedDate() {
            return this.$d(new Date(this.returnDate), 'iso')
        },
        submittingDate() {
            return this.returnDate !== '' ? new Date(this.returnDate).toISOString().substring(0,10) : ''
        }
    }
}
</script>
